'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));
var calendarField_styles = require('./calendar-field.styles-5f11b2de.js');

var CalendarField = function (_a) {
    var value = _a.value, _b = _a.format, format = _b === void 0 ? {
        month: 'long', year: 'numeric', day: 'numeric',
    } : _b, _c = _a.placeholder, placeholder = _c === void 0 ? 'Select date' : _c, _d = _a.variant, variant = _d === void 0 ? 'normal' : _d, locale = _a.locale, _e = _a.isFlexStyle, isFlexStyle = _e === void 0 ? false : _e, _f = _a.isMonthPicker, isMonthPicker = _f === void 0 ? false : _f, divProps = tslib_es6.__rest(_a, ["value", "format", "placeholder", "variant", "locale", "isFlexStyle", "isMonthPicker"]);
    var dateLabel = placeholder;
    if (value) {
        dateLabel = isMonthPicker
            ? moment(value).format('MMM, YYYY')
            : new Date(value.toDate()).toLocaleDateString(locale, format);
    }
    return (React__default.createElement(calendarField_styles.CalendarFieldStyled, tslib_es6.__assign({ className: "date-picker-select", "data-cy": "date-picker-select", "data-testid": "date-picker-select", isPlaceholderShown: !value, variant: variant }, divProps), isFlexStyle
        ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(calendarField_styles.CalendarIcon, { size: "sm", color: variant }),
            React__default.createElement(calendarField_styles.Label, { isFlexStyle: isFlexStyle }, dateLabel),
            React__default.createElement(calendarField_styles.CaretDownIcon, { variant: "adminGreyDark", className: "caret" }))) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(calendarField_styles.Label, null, dateLabel),
        React__default.createElement(calendarField_styles.CalendarIcon, { size: "sm", color: variant })))));
};

exports.CalendarField = CalendarField;
